import React from 'react';
import PropTypes from 'prop-types';
import { faSave } from '@fortawesome/pro-solid-svg-icons/faSave';
import { faUndo } from '@fortawesome/pro-solid-svg-icons/faUndo';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Formik } from 'formik';
import FontAwesome from 'utils/FA';

import './AddReminder.scss';
import { formatDateTime } from '../../utils';

const AddReminder = ({
  contactId,
  currentUser,
  onClose,
  onSubmit,
  users
}) => (
  <Formik
    initialValues={{
      body: '',
      due_date: formatDateTime(new Date(), 'iso_date'),
      owner_id: currentUser.id,
      taskable_id: contactId,
      taskable_type: 'Contact'
    }}
    validate={(values) => {
      const errors = {};

      ['owner_id', 'due_date', 'body'].forEach((k) => {
        if (!values[k] || values[k].trim() === '') {
          errors[k] = true;
        }
      });

      return errors;
    }}
    onSubmit={onSubmit}
  >
    {({
      values,
      errors,
      handleChange,
      handleSubmit,
      isSubmitting,
      setFieldValue
    }) => (
      <form onSubmit={handleSubmit}>
        <div className='add-reminder'>
          <div className='add-reminder-metadata'>
            <label className='add-reminder-owner' htmlFor='owner_id'>
              <span className='add-reminder-owner-text'>Owner</span>
              <select
                name='owner_id'
                value={values.owner_id}
                onChange={handleChange}
                className={errors.owner_id && 'add-reminder-error'}
              >
                {
                  users.map((user) => (
                    <option value={user.id} key={user.id}>{user.name}</option>
                  ))
                }
              </select>
            </label>

            <label className='add-reminder-due-date' htmlFor='due_date'>
              <span className='add-reminder-due-date-text'>Due Date</span>
              <DatePicker
                name='due_date'
                dateFormat={global.I18n.date.formats.default_date_fns}
                selected={moment(values.due_date).toDate()}
                showPopperArrow
                popperPlacement='top-end'
                onChange={
                  (value) => setFieldValue('due_date', moment(value || new Date()).format('YYYY-MM-DD'))
                }
              />
            </label>
          </div>

          <label className='add-reminder-body' htmlFor='body'>
            <span className='add-reminder-body-label'>Body</span>
            <textarea
              name='body'
              className={`add-reminder-body-text${errors.body ? ' add-reminder-error' : ''}`}
              rows={3}
              onChange={handleChange}
              value={values.body}
            />
          </label>
        </div>
        <div className='add-reminder-buttons'>
          <button className='add-reminder-close add-reminder-button' type='button' onClick={() => onClose()}>
            <FontAwesome icon={faUndo} />
          </button>
          <button className='add-reminder-submit add-reminder-button' type='submit' disabled={isSubmitting}>
            <FontAwesome icon={faSave} />
          </button>
        </div>
      </form>
    )}
  </Formik>
);

AddReminder.defaultProps = {
  contactId: '',
  currentUser: {},
  onClose: () => false,
  onSubmit: () => false,
  users: []
};

const userType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string
});

AddReminder.propTypes = {
  contactId: PropTypes.string,
  currentUser: userType,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  users: PropTypes.arrayOf(userType)
};

export default AddReminder;
